import * as z from "zod";

export const saveConnectionsToTiktokAds = {
  name: "saveConnectionsToTiktokAds" as const,
  input: z.object({
    advertiserId: z.string(),
    connections: z.array(
      z.object({
        redoSegment: z.object({ id: z.string(), name: z.string() }),
        tiktokAdsCustomAudience: z.object({ id: z.string(), name: z.string() }),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
